export default __webpack_public_path__ + "static/Streamlined-Communication-31390aa6aa674e506638167b13fd1733.webp";